export const BREEZE = "#00C6EF";

export const IMG = {
  laurie: "https://perspective.imgix.net/6886c6b1c43e1b003bd8ac7a.jpeg?auto=compress&crop=focalpoint&cropHeight=640&cropWidth=640&dpr=2&fit=crop&fp-x=0.50&fp-y=0.40&fp-z=1&h=1440&w=1440",
  carlderone: "https://perspective.imgix.net/6886cfabee9ef2003ba95250.jpeg?auto=compress,format&crop=faces,entropy&dpr=2&fit=crop&w=375",
  shaqeia: "https://perspective.imgix.net/6a67f5dc588ec8994820c129.jpeg?auto=compress,format&crop=faces,entropy&dpr=2&fit=crop&w=375",
  licensed: "https://perspective.imgix.net/688556db9b9ae6003bb23207.png?auto=compress&crop=focalpoint&cropHeight=360&cropWidth=640&dpr=2&fit=crop&fp-x=0.50&fp-y=0.43&fp-z=1&h=810&w=1440",
  culture: "https://perspective.imgix.net/6886b8527d8b19003b66df17.png?auto=compress&crop=focalpoint&cropHeight=386&cropWidth=630&dpr=2&fit=crop&fp-x=0.50&fp-y=0.47&fp-z=1.016628746625905&h=882.2049462263217&w=1440",
  founder: "https://perspective.imgix.net/6875851ec90bf2003bb089e2.jpeg?auto=compress,format&crop=faces,entropy&dpr=2&fit=crop&w=375",
};

export const CARRIERS = [
  { name: "F&G Annuities & Life", logo: "https://cdn.brandfetch.io/idijh3KNcE/w/800/h/678/theme/dark/logo.png?c=1bxid2-Pt-fvQtMo99_KJ" },
  { name: "American-Amicable", logo: "https://cdn.brandfetch.io/idGD_m02R1/w/600/h/200/theme/dark/logo.png?c=1bxid2-Pt-fvQtMo99_KJ" },
  { name: "National Life Group", logo: "https://cdn.brandfetch.io/id3NyhrX4g/w/500/h/220/theme/dark/logo.png?c=1bxid2-Pt-fvQtMo99_KJ" },
  { name: "Ameritas", logo: "https://cdn.brandfetch.io/idHa211Mjr/theme/dark/logo.svg?c=1bxid2-Pt-fvQtMo99_KJ" },
  { name: "North American", logo: "https://cdn.brandfetch.io/idS9r_91_T/theme/dark/logo.svg?c=1bxid2-Pt-fvQtMo99_KJ" },
  { name: "Americo", logo: "https://cdn.brandfetch.io/idbW3cHcVJ/w/517/h/103/theme/dark/logo.png?c=1bxid2-Pt-fvQtMo99_KJ" },
  { name: "Corebridge Financial", logo: "https://cdn.brandfetch.io/idVIfQ7UZ7/w/820/h/268/theme/dark/logo.png?c=1bxid2-Pt-fvQtMo99_KJ" },
  { name: "Transamerica", logo: "https://cdn.brandfetch.io/idMqjv2ih8/theme/dark/logo.svg?c=1bxid2-Pt-fvQtMo99_KJ" },
];

export const TESTIMONIALS = [
  {
    name: "Laurie G.",
    role: "Breeze Agent",
    img: IMG.laurie,
    quote: "BFG changed my life by giving me the tools I needed to be successful... I also now have financial freedom and can live my life how I want to... ",
    bold: "The highest paycheck I've ever had was $28,000 on an annuity commission.",
  },
  {
    name: "Carlderone G.",
    role: "Breeze Agent & Team Leader",
    img: IMG.carlderone,
    quote: "",
    bold: "Partnering with Breeze has been a game changer for sure!",
    suffix: " The consistent and quality leadership is beyond measure. You will have all of the tools and the tool box itself to get the job done!",
  },
  {
    name: "Shaqeia S.",
    role: "Breeze Agent & Team Leader",
    img: IMG.shaqeia,
    quote: "",
    bold: "In my first month with Breeze I made $33,000. And today I'm producing $25k to $30k monthly...",
    suffix: " Since being here my life has changed in ways I never expected. I was able to relocate from Ohio to California to continue building my business and creating opportunities.",
  },
];

export const RECEIPTS = [
  { amount: "$15,824.19", carrier: "ALONZO G. · ROOKIE WITH BREEZE", date: "4 DEPOSITS · OCT 2026", url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_breeze-recruit--5skwbcxb/artifacts/485ece83aefd9667_IMG_1097.jpeg" },
  { amount: "$7,943.82", carrier: "HAKEEM HOOKER · TRANSAMERICA + AEIL", date: "MARYLAND", url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_breeze-recruit--5skwbcxb/artifacts/83dbf9f3280f8074_IMG_1099.jpeg" },
  { amount: "$19,776.67", carrier: "LAURIE GUNSOLLEY · TOTAL DEPOSITS", date: "SEATTLE, WA", url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_breeze-recruit--5skwbcxb/artifacts/d7618c0358235fdc_IMG_1109.jpeg" },
  { amount: "$6,632.68", carrier: "CALDERONE R. GREEN SR. · 9 DEPOSITS", date: "MAY 24 – MAY 31", url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_breeze-recruit--5skwbcxb/artifacts/97d437f5d319cd2f_IMG_1110.jpeg" },
  { amount: "$13,857.00", carrier: "ADRIEN FORTUNE · AGENT OF THE WEEK", date: "MAY 24 – MAY 31", url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_breeze-recruit--5skwbcxb/artifacts/fd10491047904bb3_IMG_1111.jpeg" },
  { amount: "$43,295.00", carrier: "TOTAL PROCESSED DEPOSITS", date: "11 DEPOSITS · 4 CARRIERS", url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_breeze-recruit--5skwbcxb/artifacts/d8b661ec23ef1648_IMG_1101.jpeg" },
  { amount: "$13,563.95", carrier: "TOTAL DEPOSITS RECEIVED", date: "ETHOS · NATIONAL LIFE", url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_breeze-recruit--5skwbcxb/artifacts/b0545c1fd4ef1dcd_IMG_1102.jpeg" },
  { amount: "$39,091.83", carrier: "BRANDON BEAL · TOTAL DEPOSITS", date: "DALLAS, TX", url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_breeze-recruit--5skwbcxb/artifacts/4511d74ec5dcddd9_IMG_1103.jpeg" },
  { amount: "$24,486.00", carrier: "TRAVIS HINGSON · PRODUCER OF THE WEEK", date: "TEXAS", url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_breeze-recruit--5skwbcxb/artifacts/6111fe29247d289a_IMG_1098.jpeg" },
  { amount: "$5,000.00", carrier: "JAIKLAN BUSH · AEIL INS CO", date: "OKLAHOMA CITY, OK", url: "https://customer-assets-gfyr7b9c.emergentagent.net/job_breeze-recruit--5skwbcxb/artifacts/7a2066164cbdeecf_IMG_1096.jpeg" },
  { amount: "$28,000.00", carrier: "FGLIFE · ANNUITY COMMISSION", date: "06/21/2025", url: "https://perspective.imgix.net/686a1a6a02e7cc003b37de59.jpeg?auto=compress&crop=focalpoint&cropHeight=218&cropWidth=640&dpr=2&fit=crop&fp-x=0.50&fp-y=0.50&fp-z=1&h=490.5&w=1440" },
  { amount: "$5,609.28", carrier: "ACH CREDIT · PROCESSING", date: "06/18/2025", url: "https://perspective.imgix.net/686a1b1a03c1e7003bdde225.jpeg" },
  { amount: "$22,302.00", carrier: "NATIONAL LIFE · PAYABLE", date: "07/08/2025", url: "https://perspective.imgix.net/686a1c6cea5eb7003b59f34c.jpeg" },
  { amount: "$12,160.69", carrier: "ATHENE · EARNED COMMISSION", date: "06/05/2025", url: "https://perspective.imgix.net/686a1cdc66f2bb003b3d5213.jpeg" },
  { amount: "$25,951.92", carrier: "DIRECT DEPOSIT · 2 EFT PAYMENTS", date: "07/15/2025", url: "https://perspective.imgix.net/6883c30a141382003be18f7c.jpeg?auto=compress&crop=focalpoint&cropHeight=448&cropWidth=640&dpr=2&fit=crop&fp-x=0.50&fp-y=0.50&fp-z=1&h=1008&w=1440" },
  { amount: "$10,000.00", carrier: "ALLIANZ LIFE · COMMISSION", date: "07/14/2025", url: "https://perspective.imgix.net/6883c3401e21eb003b8c6861.jpg?auto=compress&crop=focalpoint&cropHeight=206&cropWidth=640&dpr=2&fit=crop&fp-x=0.50&fp-y=0.50&fp-z=1&h=463.5&w=1440" },
  { amount: "$9,800.00", carrier: "NW LIFE & ANNUITY", date: "06/26/2025", url: "https://perspective.imgix.net/686a1bdfbdbf81003bcc44b2.jpeg?auto=compress&crop=focalpoint&cropHeight=202&cropWidth=640&dpr=2&fit=crop&fp-x=0.50&fp-y=0.50&fp-z=1&h=454.5&w=1440" },
  { amount: "$11,106.00", carrier: "PAYABLE COMMISSION", date: "06/03/2025", url: "https://perspective.imgix.net/686a1d401e2b22003b701736.jpeg?auto=compress&crop=focalpoint&cropHeight=492&cropWidth=618&dpr=2&fit=crop&fp-x=0.51&fp-y=0.50&fp-z=1.0355987055016183&h=1146.4077669902913&w=1440" },
];

export const FAQS = [
  {
    q: "What does the income potential look like?",
    a: "We have agents that only make $1,000 a month, and we have agents that make multiple six-figures a year. The level of work you put in will determine your income. The sky is the limit.",
  },
  {
    q: "How quickly can I start earning?",
    a: "Assuming you're licensed, it can take 1-3 weeks to get your main carrier contracts in to then start selling. If you're unlicensed it can take 4-6 weeks to start selling.",
  },
  {
    q: "Can I build a team?",
    a: "Yes you can. We offer a builder roadmap and SOP for agents who want to recruit and scale their own agency within Breeze. We can even provide recruits at no-cost to you.",
  },
  {
    q: "What really makes Breeze Financial Group different?",
    a: "Most agencies give you poorly written scripts, sell low-quality leads, make you watch outdated training videos, and wish you good luck. We've built a system top to bottom that actually works - and we back it up with real mentorship, real infrastructure, real scalability, and real ownership.",
  },
];

export const QUIZ_QUESTION = {
  licensed: "Are You Currently A Licensed Life Insurance Agent?",
  agentType: "Are You An Agent or Agency Owner?",
  whyNew: "What's motivating you to explore a new opportunity?",
  salesExp: "What type of sales experience do you bring to the table?",
  age: "What is your age range?",
  commission: "This Opportunity Is 100% Commission-Only. We Want Entrepreneurial Minded People On Board. Do You Understand?",
  motivation: "What are you ultimately looking to build in the insurance industry?",
};

export const QUIZ_DISQUALIFIER = "I Want a Salary";

export const QUIZ_OPTIONS = {
  licensed: [
    { label: "Yes", icon: "thumbsUp" },
    { label: "Not yet", icon: "circleSlash" },
  ],
  agentType: [
    { label: "Agent", icon: "user" },
    { label: "Agency Owner", icon: "briefcase" },
  ],
  whyNew: [
    { label: "Better Compensation", icon: "badgeDollarSign" },
    { label: "Better Training & Support", icon: "graduationCap" },
    { label: "Better Leads & Technology", icon: "zap" },
    { label: "Growth & Leadership Opportunities", icon: "trendingUp" },
  ],
  salesExp: [
    { label: "Door-to-door (solar, pest, roofing, home security)", icon: "doorOpen" },
    { label: "Insurance (life, health, p&c)", icon: "shieldCheck" },
    { label: "Real Estate (agent, broker, LO)", icon: "home" },
    { label: "Automotive", icon: "car" },
    { label: "Other sales industry", icon: "badgeDollarSign" },
    { label: "No sales experience", icon: "helpCircle" },
  ],
  age: [
    { label: "18 - 25", icon: "sparkles" },
    { label: "26 - 30", icon: "zap" },
    { label: "31 - 40", icon: "flame" },
    { label: "40+", icon: "crown" },
  ],
  commission: [
    { label: "Yes I Understand", icon: "badgeCheck" },
    { label: "I Want a Salary", icon: "wallet" },
  ],
  motivation: [
    { label: "Consistent source of part-time income", icon: "wallet" },
    { label: "A full-time insurance career", icon: "briefcase" },
    { label: "My own team or agency", icon: "users" },
    { label: "A long-term business with leadership opportunities", icon: "crown" },
  ],
};
